import { createSlice } from '@reduxjs/toolkit'

export const openSimulatorPolicySlice = createSlice({
    name: 'openSimulatorPolicy',
    initialState: {
        open: false,
    },
    reducers: {
        setOpenSimulatorPolicy: (state, action) => {
            state.open = action.payload;
        },
    },
})

export const { setOpenSimulatorPolicy } = openSimulatorPolicySlice.actions;

export const getOpenSimulatorPolicy = (state) => state.openSimulatorPolicy.open;

export default openSimulatorPolicySlice.reducer